import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { AhaaGoodsCard, FoodGoodsCard } from '../../common/components';
import { useClientLayoutEffect } from '../../common/hooks/use-client-layout-effect';
import { useMobile } from '../../common/hooks/use-mobile';
import { useResizeObserver } from '../../common/hooks/use-resize-observer';
import { transformInterval, transformPageMargins } from '../../common/utils';
import { classNames } from '../../common/utils/classnames';
import { scrollToVisible } from '../../common/utils/scroll-to-visible';
import { useDesignContext } from '../../design-provider';
import { useUpdateEffect } from '../../common/hooks/use-update-effect';
import { get } from 'lodash-es';
import { useWrapStyle } from '../../common/hooks/use-wrap-style';
export var WithTitle2 = function WithTitle2(props) {
  var _a;
  var _props$setMethod = props.setMethod,
    setMethod = _props$setMethod === void 0 ? 1 : _props$setMethod,
    goodsGroupList = props.goodsGroupList,
    goodsGroupList2 = props.goodsGroupList2,
    goodsGap = props.goodsGap,
    pagePadding = props.pagePadding,
    bgColor = props.bgColor,
    goodsCardStyle = props.goodsCardStyle,
    filterSoldOut = props.filterSoldOut,
    bgSetting = props.bgSetting,
    bgPicture = props.bgPicture,
    dataset = props.dataset,
    onAddCart = props.onAddCart,
    onCollect = props.onCollect,
    triggerRequest = props.triggerRequest;
  var _useDesignContext = useDesignContext(),
    local = _useDesignContext.local,
    designOnLink = _useDesignContext.designOnLink;
  var curGoodsGroupList = setMethod === 1 ? goodsGroupList : goodsGroupList2;
  var _useState = useState(function () {
      return curGoodsGroupList[0];
    }),
    active = _useState[0],
    setActive = _useState[1];
  var goodsListData = get(dataset, active.id);
  var displayGoodsList = (get(goodsListData, 'data', []) || []).slice(0, 12);
  var tabsEl = useRef(null);
  var mobile = useMobile();
  var linkPath = designOnLink((_a = active.target) !== null && _a !== void 0 ? _a : {});
  useUpdateEffect(function () {
    var _a;
    if (setMethod === 1) {
      triggerRequest('loadGoodsList', {
        datasetKey: active.id,
        requestData: Object.assign(Object.assign({}, (_a = active.target) !== null && _a !== void 0 ? _a : {}), {
          page: 1,
          perPage: 6,
          filterSoldOut: filterSoldOut
        })
      });
    } else {
      triggerRequest('loadGoodsList2', {
        datasetKey: active.id,
        requestData: {
          ids: active.goodsList.map(function (item) {
            return item.csku;
          }).join(','),
          filterSoldOut: filterSoldOut
        }
      });
    }
  }, [active]);
  function isActive(value) {
    return value.id === active.id;
  }
  /**
   * 已激活 tab 滚动至可视区域
   *
   * @param behavior 滚动行为
   */
  function activeScrollToVisible(behavior) {
    if (tabsEl.current) {
      var index = curGoodsGroupList.findIndex(isActive);
      scrollToVisible(tabsEl.current, index, behavior);
    }
  }
  useResizeObserver(function () {
    return activeScrollToVisible();
  }, tabsEl);
  useClientLayoutEffect(function () {
    return activeScrollToVisible('smooth');
  }, [active]);
  var GoodsCardComponent = goodsCardStyle === 1 ? AhaaGoodsCard : FoodGoodsCard;
  var wrapStyle = useWrapStyle(bgSetting, bgPicture, bgColor);
  return _jsx("section", Object.assign({
    className: 'w-full',
    style: wrapStyle
  }, {
    children: _jsx("div", Object.assign({
      className: 'container'
    }, {
      children: _jsxs("section", Object.assign({
        className: classNames('w-full py-3 bg-white', 'cq-pc:py-7.5'),
        style: {
          paddingLeft: transformPageMargins(pagePadding, mobile),
          paddingRight: transformPageMargins(pagePadding, mobile)
        }
      }, {
        children: [_jsx("header", Object.assign({
          className: 'flex justify-center'
        }, {
          children: _jsx("ul", Object.assign({
            ref: tabsEl,
            className: 'flex flex-nowrap mb-5 bg-white rounded overflow-x-scroll hide-scrollbar'
          }, {
            children: curGoodsGroupList.map(function (item) {
              return _jsx("li", Object.assign({
                className: classNames('flex-shrink-0 flex items-center justify-center px-4 h-8 text-sm text-ahaa-black-1 cursor-pointer', 'cq-pc:min-w-60 cq-pc:h-11.5 cq-pc:text-base', {
                  'font-medium bg-ahaa-black-5 rounded': isActive(item)
                }),
                onClick: function onClick() {
                  if (!isActive(item)) setActive(item);
                }
              }, {
                children: item.title
              }), item.id);
            })
          }))
        })), _jsx("main", Object.assign({
          className: classNames('grid grid-cols-2 w-full', 'cq-pc:grid-cols-6'),
          style: {
            gap: transformInterval(goodsGap, mobile, 'proudcCard')
          }
        }, {
          children: displayGoodsList.map(function (item) {
            return _jsx(GoodsCardComponent, {
              className: 'col-span-1',
              goods: item,
              onAddCart: onAddCart,
              onCollect: onCollect
            }, item.csku);
          })
        })), _jsx("footer", Object.assign({
          className: 'w-full'
        }, {
          children: _jsx("button", Object.assign({
            className: classNames('flex items-center justify-center mx-auto mt-4 w-full h-9 text-xs border border-ahaa-black-5 rounded text-ahaa-black-2 bg-white', 'cq-pc:mt-10 cq-pc:w-33 cq-pc:text-sm cq-pc:text-ahaa-black-1')
          }, {
            children: _jsx("a", Object.assign({
              href: linkPath
            }, {
              children: local.goods.viewMoreButtonText
            }))
          }))
        }))]
      }))
    }))
  }));
};